import { state_ctrl_factory } from 'ww2_analytics/common/state_ctrl';


const simple_table = () => ({
    template: require('./template.html'),
    restrict: 'E',
    scope: {
        getTableData: '@',
        captionText: '@?',
        captionUrl: '@?',
    },
    controller: state_ctrl_factory('jsonrpc', function(jsonrpc, $scope, model) {
        return jsonrpc.callServiceMethod($scope.getTableData, model).then(function(resp) {
            $scope.vm = {};
            Object.assign($scope.vm, resp);
        });
    }),
});

export default function(app) {
    app.directive('simpleTable', simple_table);
};
